'use strict';

var _classCallCheck = require("/Users/huynhtuan/dev/bacoor/bacoor-wordpress/tomochain-services/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var internals = {};

module.exports = /*#__PURE__*/function () {
  function _class(key, path, parent, reference) {
    _classCallCheck(this, _class);

    this.key = key;
    this.path = path;
    this.parent = parent;
    this.reference = reference;
  }

  return _class;
}();